/**
 * info-card.js
 */

import React from 'react';
import { alpha } from '@mui/material/styles';
import { Typography, Tooltip } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import Icon from 'components/icon';


const useStyles = makeStyles(theme => ({
  root: {
    textAlign: 'left',
    backgroundColor: theme.palette.sys.surfaceContainer,
    padding: `${theme.spacing(0.25)} ${theme.spacing(1.25)}`,
    borderRadius: 4,
    transition: `${theme.transitions.duration.shorter}ms ${theme.transitions.easing.easeOut}`,
    '&:hover': {
      backgroundColor: alpha(theme.palette.sys.surfaceContainer, 0.6),
    }
  },
  icon: {
    color: theme.palette.sys.onSurfaceVariant,
    fontSize: theme.typography.sizes[7],
    marginRight: theme.spacing(1),
  },
  value: {
    fontWeight: 'bold',
    color: theme.palette.primary.colors[5],
    marginRight: theme.spacing(1),
  },
  titles: {
    display: 'flex',
    flexDirection: 'column',
    marginTop: 1,
  },
  title: {
    textTransform: 'uppercase',
    fontWeight: 'bold',
    color: theme.palette.sys.onSurface,
    lineHeight: '16px',
  },
  subtitle: {
    color: theme.palette.sys.onSurfaceVariant,
    fontSize: theme.typography.sizes[0],
    lineHeight: '12px',
  },
}));


export default function InfoCard(props) {
  const {
    iconId,
    value,
    title,
    subtitle,
    tooltip,
    additional,
  } = props;
  const classes = useStyles();

  return (
    <Tooltip arrow title={tooltip || ''}>
      <div className={`flex-hc element-default-box-shadow ${classes.root}`}>

        {/* ICON */}
        <Icon type={iconId} className={classes.icon} />

        {/* VALUE */}
        <Typography
          variant='h4'
          className={classes.value}
          data-testtype={`quick-link-value`}
        >
          {value}
        </Typography>

        {/* TITLES */}
        <div className={classes.titles}>
          <Typography variant='body2' className={classes.title} sx={{ fontSize: subtitle ? 'sizes.2' : 'sizes.5' }}>{title}</Typography>
          {subtitle &&
            <Typography variant='caption' className={classes.subtitle}>{subtitle}</Typography>
          }
        </div>

        {/* ADDITIONAL */}
        {additional && <div>{additional}</div>}

      </div>
    </Tooltip>
  );
}